// extracted by mini-css-extract-plugin
export default {"container":"BookingSuccess_container__LuYn1","message":"BookingSuccess_message__-ReIq","info":"BookingSuccess_info__0VHyD","backButton":"BookingSuccess_backButton__3nDz1"};